import { render, staticRenderFns } from "./Storys.vue?vue&type=template&id=11a3dc57&scoped=true&"
import script from "./Storys.vue?vue&type=script&lang=js&"
export * from "./Storys.vue?vue&type=script&lang=js&"
import style0 from "./Storys.vue?vue&type=style&index=0&id=11a3dc57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a3dc57",
  null
  
)

export default component.exports